/* Black Run: movimento da home e navegação sempre no topo. */
(() => {
  // Toda página nova começa no topo; só desce se o link pedir uma âncora.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const initialHash = location.hash;
  const toTop = () => {
    if (!initialHash) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  };
  window.addEventListener('pageshow', toTop);
  document.addEventListener('DOMContentLoaded', toTop);

  // Âncoras da mesma página rolam suave sem deixar o hash na URL,
  // assim recarregar ou voltar não abre a página no meio.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    const target = document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    // fecha o carrinho/menu lateral antes de rolar até a seção
    const panel = link.closest('dialog, cart-drawer-component, header-drawer, details[open]');
    if (panel) {
      if (typeof panel.close === 'function') panel.close();
      else if (panel.tagName === 'DETAILS') panel.removeAttribute('open');
      document.querySelectorAll('dialog[open]').forEach((d) => d.close());
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', location.pathname + location.search);
  });
  if (initialHash) {
    const target = document.querySelector(initialHash);
    history.replaceState(null, '', location.pathname + location.search);
    if (target) window.addEventListener('load', () => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }

  // Filtro por marca nas páginas de modelo (camisetas / corta-ventos).
  const chips = document.querySelector('[data-br-brand-filter]');
  if (chips) {
    chips.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-brand]');
      if (!chip) return;
      const brand = chip.dataset.brand.toLowerCase();
      chips.querySelectorAll('[data-brand]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      document.querySelectorAll('.product-grid__item').forEach((item) => {
        const title = (item.querySelector('a[aria-label]')?.getAttribute('aria-label') || item.textContent).toLowerCase();
        item.hidden = Boolean(brand) && !title.includes('· ' + brand);
      });
    });
  }

  // Páginas de política são geradas pela Shopify com título em inglês.
  const policyTitles = {
    'privacy-policy': 'Política de Privacidade',
    'refund-policy': 'Trocas e devoluções',
    'shipping-policy': 'Frete e entrega',
    'terms-of-service': 'Termos de uso',
    'contact-information': 'Contato',
  };
  const policy = location.pathname.match(/\/policies\/([^/?#]+)/);
  if (policy && policyTitles[policy[1]]) {
    const h1 = document.querySelector('.shopify-policy__title h1, main h1');
    if (h1) h1.textContent = policyTitles[policy[1]];
    document.title = `${policyTitles[policy[1]]} | B4You - Black Run`;
  }

  // Entrada dos elementos ao rolar.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = document.querySelectorAll('[data-br-reveal], .br-brand, .br-perk, .br-step');
  if (reduce || !('IntersectionObserver' in window)) return;
  items.forEach((el) => el.classList.add('br-reveal'));
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const siblings = [...el.parentElement.children];
        el.style.transitionDelay = `${Math.min(siblings.indexOf(el), 12) * 45}ms`;
        el.classList.add('is-in');
        io.unobserve(el);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach((el) => io.observe(el));
})();
